import { ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import CreatePipelineDialog from './CreatePipelineDialog/CreatePipelineDialog';
import { Trans } from 'react-i18next';
import { useAppDispatch } from '../../store/hooks';
import { toggleAddPipelineDialogOpenf, togglePauseTut } from '../../store/tutorial/tutorialSlice';

const CreatePipelineEntry = (): JSX.Element => {
  const [open, setOpen] = useState(false);
  const dispatch = useAppDispatch();
  const handleClose = () => {
    setOpen(false);
    dispatch(togglePauseTut())
  };

  return (
    <>
      <ListItemButton onClick={() => {setOpen(true); dispatch(togglePauseTut())}}>
        <ListItemIcon>
          <AddIcon />
        </ListItemIcon>
        <ListItemText>
          <Trans>Add Pipeline</Trans>
        </ListItemText>
      </ListItemButton>
      <CreatePipelineDialog open={open} onClose={handleClose} />
    </>
  );
};

export default CreatePipelineEntry;
